// components/FeatureSection.jsx
import React from "react";
import "./featuresection.css";

const IndoChineseFeatureSection = () => {
  return (
    <section className="feature-wrapper">
      <div className="image-container">
        <img src="/Images/best coffee shop mandurah.webp" alt="Cafe" className="animated-image" loading="lazy"/>
        <div className="circle yellow"></div>
        <div className="circle white"></div>
        <div className="sb-experience">
          <div className="sb-exp-content">
            <p className="sb-h1 sb-mb-10">
              {" "}
              <span> 17 </span>
            </p>
            <p class="sb-h3">
              {" "}
              <span> Years Experiense </span>
            </p>
          </div>
        </div>
      </div>

      <div className="text-container">
        {/* <h2>We are doing more than you expect</h2> */}

        <div className="feature-block">
          {/* <span className="monoton">01</span> */}
          <div>
            <h3>Explore the Best Indo-Chinese Fusion in Mandurah</h3>
            <p>
              Spice up your day with bold and flavorful Indo-Chinese food in
              Mandurah at Mandurah Cafe. Our fusion dishes like Chilli Paneer,
              Hakka Noodles, and Gobi Manchurian are customer favorites for a
              reason. Dive into this vibrant blend of Indian and Chinese cuisine
              right here in the city center.
            </p>
          </div>
        </div>

        <div className="feature-block">
          {/* <span className="monoton">02</span> */}
          <div>
            {/* <h3>Fresh, organic ingredients</h3> */}
            <p>
              We bring you the ultimate Indo-Chinese experience using fresh
              vegetables, exotic spices, and wok-style cooking. Each plate is a
              flavor explosion, making us one of the top spots for Indo-Chinese
              in Mandurah. It's the perfect balance of spicy, tangy, and savory.
            </p>
          </div>
        </div>

        <div className="feature-block">
          {/* <span className="monoton">03</span> */}
          <div>
            {/* <h3>Own fast delivery</h3> */}
            <p>
              Whether you're craving a spicy lunch or planning a dinner outing,
              Mandurah Cafe serves the most authentic Indo-Chinese takeaway in
              Mandurah. Dine in for a warm experience or grab your favorites
              to-go - our kitchen is always ready to serve hot and fresh meals.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndoChineseFeatureSection;
